"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _spauiSelect = _interopRequireDefault(require("@tencent/spaui-select"));

var _spauiInput = _interopRequireDefault(require("@tencent/spaui-input"));

var _spauiFormgroup = _interopRequireDefault(require("@tencent/spaui-formgroup"));

var _spauiButton = _interopRequireDefault(require("@tencent/spaui-button"));

var _info = _interopRequireDefault(require("./info"));

var _index = require("./utils/index");

var _pagebar_compact_props = _interopRequireDefault(require("./pagebar_compact_props"));

var _index2 = require("./config/index");

var _pagebar_props = require("./pagebar_props");

var _classname_map = _interopRequireDefault(require("./config/classname_map"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var PageBar =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(PageBar, _PureComponent);

  function PageBar(props) {
    var _this;

    _classCallCheck(this, PageBar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PageBar).call(this, props)); // focus的时候要加上active的class

    _this.state = {
      minPaginationClassName: '',
      inputValue: null
    }; // 语言文案

    _this.locale = (0, _spauiUtils.objectAssign)({}, _index2.defaultLocale, props.locale);
    _this.handlePageSizeChange = _this.handlePageSizeChange.bind(_assertThisInitialized(_this));
    _this.handleInputChange = _this.handleInputChange.bind(_assertThisInitialized(_this));
    _this.handleInputKeyPress = _this.handleInputKeyPress.bind(_assertThisInitialized(_this));
    _this.handleInputFocus = _this.handleInputFocus.bind(_assertThisInitialized(_this));
    _this.handleInputBlur = _this.handleInputBlur.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PageBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // 检查css与js版本
      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _compactProps = (0, _pagebar_compact_props["default"])(this.props),
          value = _compactProps.value;

      var _compactProps2 = (0, _pagebar_compact_props["default"])(nextProps),
          nextPropsValue = _compactProps2.value; // 语言文案


      this.locale = (0, _spauiUtils.objectAssign)({}, _index2.defaultLocale, nextProps.locale); // 如果页码有变化，需要将临时的输入值清空

      if (value !== nextPropsValue) {
        this.setState({
          inputValue: null
        });
      }
    }
  }, {
    key: "getClassNameMap",
    value: function getClassNameMap() {
      var _this$props$className = this.props.classNameMap,
          classNameMap = _this$props$className === void 0 ? {} : _this$props$className;
      return _objectSpread({}, _classname_map["default"], {}, classNameMap);
    }
  }, {
    key: "handleChange",
    value: function handleChange(event, currentValue, currentPageSize) {
      var onChange = this.props.onChange;

      var _compactProps3 = (0, _pagebar_compact_props["default"])(this.props),
          propsPageSize = _compactProps3.pageSize,
          propsValue = _compactProps3.value;

      var pageSize = (0, _index["int"])(typeof currentPageSize !== 'undefined' ? currentPageSize : propsPageSize);
      var value = (0, _index["int"])(currentValue);

      if ((0, _spauiUtils.isFunction)(onChange)) {
        if (typeof currentPageSize === 'undefined') {
          if (value != propsValue) {
            onChange(event, value, pageSize);
          }
        } else {
          onChange(event, value, pageSize);
        }
      }
    }
  }, {
    key: "handlePageSizeChange",
    value: function handlePageSizeChange(event, currentPageSize) {
      var pageSize = (0, _index["int"])(currentPageSize);

      var _compactProps4 = (0, _pagebar_compact_props["default"])(this.props),
          value = _compactProps4.value,
          onPageSizeChange = _compactProps4.onPageSizeChange,
          oldPageSize = _compactProps4.pageSize,
          totalSize = _compactProps4.totalSize;

      var newTotalPage = Math.ceil(totalSize, pageSize) || 0;
      var newValue = 1; // 新页码数量比旧页码数量大

      if (pageSize > oldPageSize) {
        newValue = Math.ceil(value * oldPageSize / pageSize);
      } else {
        newValue = Math.ceil(((value - 1) * oldPageSize + 1) / pageSize);
      }

      if (newValue < 1) {
        newValue = 1;
      } else if (newValue > newTotalPage) {
        newValue = newTotalPage;
      }

      if ((0, _spauiUtils.isFunction)(onPageSizeChange)) {
        onPageSizeChange(newValue, pageSize);
      } else {
        this.handleChange(event, newValue, pageSize);
      }
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(event) {
      var _compactProps5 = (0, _pagebar_compact_props["default"])(this.props),
          totalPage = _compactProps5.totalPage;

      var inputValue = (0, _index["int"])(event.target.value, '');

      if (inputValue > -1 && inputValue <= totalPage) {
        this.setState({
          inputValue: inputValue
        });
      }
    }
  }, {
    key: "useInputValue",
    value: function useInputValue(event) {
      var changeBlur = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var _compactProps6 = (0, _pagebar_compact_props["default"])(this.props),
          totalPage = _compactProps6.totalPage;

      var inputValue = this.state.inputValue;
      var result = (0, _index["int"])(inputValue, 1);

      if (result > 0 && result <= totalPage && (typeof inputValue === 'number' || inputValue)) {
        this.handleChange(event, result); // 是否立即失去焦点

        if (changeBlur && event && event.target && event.target.blur) {
          event.target.blur();
        }
      }
    }
  }, {
    key: "handleInputKeyPress",
    value: function handleInputKeyPress(event) {
      var charCode = (0, _index["int"])(event.charCode);

      if (charCode === 13) {
        // 用户enter
        this.useInputValue(event, true);
      }
    }
  }, {
    key: "handleInputFocus",
    value: function handleInputFocus() {
      this.setState({
        minPaginationClassName: 'pagination active'
      });
    }
  }, {
    key: "handleInputBlur",
    value: function handleInputBlur(event) {
      this.useInputValue(event);
      this.setState({
        minPaginationClassName: 'pagination'
      });
    }
  }, {
    key: "getMiniPageButtonComponent",
    value: function getMiniPageButtonComponent() {
      var _this2 = this;

      var _compactProps7 = (0, _pagebar_compact_props["default"])(this.props),
          value = _compactProps7.value,
          totalPage = _compactProps7.totalPage,
          _compactProps7$showPa = _compactProps7.showPageJudge,
          showPageJudge = _compactProps7$showPa === void 0 ? true : _compactProps7$showPa;

      var beforeDisabled = value < 2;
      var afterDisabled = value >= totalPage;
      var _this$state = this.state,
          minPaginationClassName = _this$state.minPaginationClassName,
          inputValue = _this$state.inputValue;
      var inputShowValue = _typeof(inputValue) !== 'object' ? inputValue : value;
      var classNameMap = this.getClassNameMap();
      return _react["default"].createElement("div", {
        className: classNameMap.PageBarInnerClassName
      }, _react["default"].createElement("span", {
        className: (0, _classnames["default"])(classNameMap.PageBarRollClassName, 'prev', {
          disabled: beforeDisabled
        }),
        onClick: function onClick(event) {
          if (!beforeDisabled) {
            _this2.handleChange(event, value - 1);
          }
        }
      }, _react["default"].createElement("a", {
        title: beforeDisabled ? '' : value - 1,
        style: {
          cursor: beforeDisabled ? '' : 'pointer'
        },
        className: "spaui-pagebar-prev"
      }, (0, _index.setArrowLabel)())), _react["default"].createElement("div", {
        className: minPaginationClassName || 'pagination'
      }, _react["default"].createElement("label", {
        className: "spaui-pagebar-input"
      }, _react["default"].createElement("input", {
        disabled: !showPageJudge,
        type: "text",
        className: "spaui-pagebar-current",
        value: inputShowValue,
        onFocus: this.handleInputFocus,
        onBlur: this.handleInputBlur,
        onChange: this.handleInputChange,
        onKeyPress: this.handleInputKeyPress
      }), _react["default"].createElement("span", {
        className: "fixnum spaui-pagebar-count"
      }, _react["default"].createElement("i", {
        className: "spaui-pagebar-divier"
      }, "/"), _react["default"].createElement("span", {
        className: "spaui-pagebar-total"
      }, totalPage)))), _react["default"].createElement("span", {
        className: (0, _classnames["default"])(classNameMap.PageBarRollClassName, 'back', {
          disabled: afterDisabled
        }),
        onClick: function onClick(event) {
          if (!afterDisabled) {
            _this2.handleChange(event, value + 1);
          }
        }
      }, _react["default"].createElement("a", {
        title: afterDisabled ? '' : value + 1,
        style: {
          cursor: afterDisabled ? '' : 'pointer'
        },
        className: "spaui-pagebar-next"
      }, (0, _index.setArrowLabel)())));
    }
    /**
     * 正常页码按钮的组件模版
     * @private
     * @return {object}        组件模版
     */

  }, {
    key: "getNormalPageButtonComponent",
    value: function getNormalPageButtonComponent() {
      var _this3 = this;

      var _compactProps8 = (0, _pagebar_compact_props["default"])(this.props),
          propsValue = _compactProps8.value,
          totalPage = _compactProps8.totalPage,
          buttonClassName = _compactProps8.buttonClassName,
          propsButtonCount = _compactProps8.buttonCount,
          setButtonLabel = _compactProps8.setButtonLabel,
          propsSetButtonClassName = _compactProps8.setButtonClassName,
          _compactProps8$showTo = _compactProps8.showTotalPageButton,
          propsShowTotalPageButton = _compactProps8$showTo === void 0 ? true : _compactProps8$showTo,
          _compactProps8$fixedS = _compactProps8.fixedShowPageSizeButton,
          fixedShowPageSizeButton = _compactProps8$fixedS === void 0 ? false : _compactProps8$fixedS;

      var value = (0, _index["int"])(propsValue);
      var buttonCount = (0, _index["int"])(propsButtonCount, 8);
      var buttonTypeName = {
        pageButton: 'pageButton',
        prevPageButton: 'prevPageButton',
        nextPageButton: 'nextPageButton',
        totalPageButton: 'totalPageButton',
        ellipsisButton: 'ellipsisButton'
      };
      var classNameMap = this.getClassNameMap();

      var onClickPageButton = function onClickPageButton(event, pageValue) {
        var result = (0, _index["int"])(pageValue, 1);

        if (result < 1) {
          result = 1;
        }

        if (result > totalPage) {
          result = totalPage;
        }

        _this3.handleChange(event, result);
      };

      var pageNumber = [];
      var endPageNo = totalPage;
      var wetcStart = false;
      var wetcEnd = false;
      var wFirst = false;
      var wEnd = false;
      var startPageNo = 1;
      var intnum = 0;
      var i = 0;
      var className = (0, _classnames["default"])(buttonClassName);

      var setButtonClassName = function setButtonClassName() {};

      var showTotalPageButton = true;

      if ((0, _spauiUtils.isFunction)(propsSetButtonClassName)) {
        setButtonClassName = propsSetButtonClassName;
      } // 参数构造不了正确的页码


      if (value < 1 || totalPage <= 1 && !fixedShowPageSizeButton || value > totalPage) {
        className = (0, _classnames["default"])(className, setButtonClassName(buttonTypeName.totalPageButton, '', false));
        return null;
      }

      if (totalPage > buttonCount) {
        intnum = (0, _index["int"])((buttonCount - 2) / 2);
        startPageNo = value - intnum;
        endPageNo = value + intnum;

        if (startPageNo >= 3) {
          wetcStart = true;
        }

        if (startPageNo >= 2) {
          wFirst = true;
        }

        if (endPageNo < totalPage) {
          wEnd = true;
        }

        if (endPageNo + 1 < totalPage) {
          wetcEnd = true;
        }

        if (startPageNo <= 1) {
          startPageNo = 1;
          endPageNo = buttonCount - 1;
        }

        if (endPageNo >= totalPage) {
          startPageNo = totalPage - buttonCount + 2;
          endPageNo = totalPage;
        }
      }

      for (i = startPageNo; i <= endPageNo; i++) {
        pageNumber.push(i);
      } // 有省略号且指定了false才设置为false


      if (wetcEnd && !propsShowTotalPageButton) {
        showTotalPageButton = false;
      }

      return _react["default"].createElement("ul", {
        className: "pagination"
      }, _react["default"].createElement("li", {
        className: (0, _classnames["default"])(classNameMap.PageBarRollClassName, 'page-forward', className, setButtonClassName(buttonTypeName.prevPageButton, value - 1, false), {
          disabled: value === 1
        })
      }, _react["default"].createElement("a", {
        "data-index": value - 1,
        title: value - 1,
        onClick: function onClick(event) {
          return onClickPageButton(event, value - 1);
        },
        className: "spaui-pagebar-prev"
      }, setButtonLabel(buttonTypeName.prevPageButton, value - 1, false))), wFirst ? _react["default"].createElement("li", {
        className: (0, _classnames["default"])(className, setButtonClassName(buttonTypeName.pageButton, 1, value === 1), {
          active: value === 1
        })
      }, _react["default"].createElement("a", {
        "data-index": "1",
        title: "1",
        className: "spaui-cursor-pointer",
        onClick: function onClick(event) {
          return onClickPageButton(event, 1);
        }
      }, setButtonLabel(buttonTypeName.pageButton, 1, false))) : null, wetcStart ? _react["default"].createElement("li", {
        className: (0, _classnames["default"])(className, setButtonClassName(buttonTypeName.ellipsisButton, '', false))
      }, _react["default"].createElement("span", {
        className: "spaui-pagebar-ellipsis"
      }, setButtonLabel(buttonTypeName.ellipsisButton, '', false))) : null, pageNumber.map(function (pageItem) {
        var item = (0, _index["int"])(pageItem);
        return _react["default"].createElement("li", {
          key: item,
          className: (0, _classnames["default"])(className, setButtonClassName(buttonTypeName.pageButton, item, value === item), {
            active: value === item
          })
        }, _react["default"].createElement("a", {
          "data-index": item,
          title: item,
          className: "spaui-cursor-pointer",
          onClick: function onClick(event) {
            return onClickPageButton(event, item);
          }
        }, setButtonLabel(buttonTypeName.pageButton, item, false)));
      }), wetcEnd ? _react["default"].createElement("li", {
        className: (0, _classnames["default"])(className, setButtonClassName(buttonTypeName.ellipsisButton, '', false))
      }, _react["default"].createElement("span", {
        className: "spaui-pagebar-ellipsis"
      }, setButtonLabel(buttonTypeName.ellipsisButton, '', false))) : null, wEnd && endPageNo !== totalPage && showTotalPageButton ? _react["default"].createElement("li", {
        className: (0, _classnames["default"])(className, setButtonClassName(buttonTypeName.pageButton, totalPage, value === totalPage), {
          active: value === totalPage
        })
      }, _react["default"].createElement("a", {
        "data-index": totalPage,
        title: totalPage,
        className: "spaui-cursor-pointer",
        onClick: function onClick(event) {
          return onClickPageButton(event, totalPage);
        }
      }, setButtonLabel(buttonTypeName.pageButton, totalPage, false))) : null, _react["default"].createElement("li", {
        className: (0, _classnames["default"])(classNameMap.PageBarRollClassName, 'backward', className, setButtonClassName(buttonTypeName.nextPageButton, value + 1, false), {
          disabled: value === totalPage
        })
      }, _react["default"].createElement("a", {
        "data-index": value + 1,
        title: value + 1,
        onClick: function onClick(event) {
          return onClickPageButton(event, value + 1);
        },
        className: "spaui-pagebar-next"
      }, setButtonLabel(buttonTypeName.nextPageButton, value + 1, false))));
    }
    /**
     * 页码信息的组件模版
     * @private
     * @return {object}        组件模版
     */

  }, {
    key: "getPageInfoComponent",
    value: function getPageInfoComponent() {
      var _this$props = this.props,
          selectClassName = _this$props.selectClassName,
          selectPlacement = _this$props.selectPlacement,
          showTotalSize = _this$props.showTotalSize,
          selectAutoPlacementBasic = _this$props.selectAutoPlacementBasic;

      var _compactProps9 = (0, _pagebar_compact_props["default"])(this.props),
          pageSize = _compactProps9.pageSize,
          pageSizeList = _compactProps9.pageSizeList,
          totalSize = _compactProps9.totalSize;

      var totalSizeLabel = showTotalSize ? this.locale.totalSizeLabel.replace('{value}', totalSize) : '';
      var pageSizeArray = [];
      pageSizeList.map(function (item) {
        if (!item) {
          return;
        }

        if ((0, _spauiUtils.isObject)(item)) {
          pageSizeArray.push(item);
        } else {
          pageSizeArray.push({
            label: "".concat(item),
            value: "".concat(item)
          });
        }
      });
      return _react["default"].createElement("div", {
        className: "page-info"
      }, pageSizeList.length > 0 ? _react["default"].createElement("span", null, _react["default"].createElement("span", {
        className: "txt"
      }, totalSizeLabel, this.locale.pageSizeChangeLabel), _react["default"].createElement(_spauiSelect["default"], {
        data: pageSizeArray,
        onChange: this.handlePageSizeChange,
        placement: selectPlacement,
        autoPlacementBasic: selectAutoPlacementBasic,
        placeholder: "".concat(pageSize),
        tip: '',
        value: "".concat(pageSize),
        className: "".concat(selectClassName, " spaui-dropdown")
      }), _react["default"].createElement("span", {
        className: "txt"
      }, this.locale.size)) : totalSizeLabel + this.locale.pageSizeLabel.replace('{value}', pageSize || ''));
    }
  }, {
    key: "getJudgeComponent",
    value: function getJudgeComponent() {
      var _this4 = this;

      var _compactProps10 = (0, _pagebar_compact_props["default"])(this.props),
          value = _compactProps10.value,
          totalPage = _compactProps10.totalPage;

      var onButtonClick = function onButtonClick(event) {
        var inputValue = _this4.state.inputValue;
        var result = (0, _index["int"])(inputValue, 1);

        if (result > 0 && result <= totalPage) {
          _this4.handleChange(event, result);
        }
      };

      var inputValue = this.state.inputValue;
      var inputShowValue = '';

      if (typeof inputValue !== 'undefined') {
        if (_typeof(inputValue) === 'object') {
          inputShowValue = inputValue || '';
        } else {
          inputShowValue = inputValue;
        }
      } else {
        inputShowValue = value;
      }

      return _react["default"].createElement(_spauiFormgroup["default"], null, _react["default"].createElement(_spauiInput["default"], {
        value: inputShowValue,
        onChange: this.handleInputChange,
        onKeyPress: this.handleInputKeyPress
      }), _react["default"].createElement(_spauiButton["default"], {
        onClick: function onClick(event) {
          return onButtonClick(event);
        }
      }, this.locale.goToLabel));
    } // 是否隐藏

  }, {
    key: "isHide",
    value: function isHide() {
      var show = this.props.show;

      var _compactProps11 = (0, _pagebar_compact_props["default"])(this.props),
          totalPage = _compactProps11.totalPage,
          hide = _compactProps11.hide;

      var _show = show;
      var result = false;

      if (typeof hide !== 'undefined') {
        _show = !hide;
      }

      if (!_show || totalPage < 1) {
        result = true;
      }

      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          type = _this$props2.type,
          showPageInfo = _this$props2.showPageInfo,
          showTotalPage = _this$props2.showTotalPage,
          showPageJudge = _this$props2.showPageJudge;

      var _compactProps12 = (0, _pagebar_compact_props["default"])(this.props),
          totalPage = _compactProps12.totalPage;

      var hide = this.isHide();
      var classNameMap = this.getClassNameMap();

      if (hide) {
        return null;
      }

      return _react["default"].createElement("div", (0, _spauiUtils.globalProps)(this.props, {
        className: (0, _classnames["default"])(classNameMap.PageBar, {
          mini: type === 'mini'
        }),
        supportAllEvents: true
      }, PageBar, this.props), type !== 'mini' && showPageInfo ? this.getPageInfoComponent() : null, type === 'mini' ? this.getMiniPageButtonComponent() : this.getNormalPageButtonComponent(), type !== 'mini' && totalPage > 0 && showTotalPage ? _react["default"].createElement("span", {
        className: "page-info"
      }, _react["default"].createElement("span", {
        className: "txt"
      }, this.locale.totalPageButton.replace('{value}', totalPage))) : null, type !== 'mini' && totalPage > 1 && showPageJudge ? this.getJudgeComponent() : null);
    }
  }]);

  return PageBar;
}(_react.PureComponent); // 组件标记


_defineProperty(PageBar, "propTypes", _pagebar_props.propTypes);

_defineProperty(PageBar, "defaultProps", _pagebar_props.defaultProps);

(0, _spauiUtils.setComponentMark)(PageBar, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = PageBar;
exports["default"] = _default;